import type { FooterGroup } from "./types";

export const data: FooterGroup[] = [
  {
    title: "Legal",
    links: [
      { label: "Privacy policy", link: "/privacy-policy" },
      { label: "Terms of service", link: "/terms-of-service" },
      { label: "Legal notice", link: "/legal-notice" },
      { label: "Accessibility", link: "/accessibility" },
    ],
  },
  {
    title: "Project",
    links: [
      { label: "Wall of love", link: "/testimonials" },
      { label: "Contribute", link: "/tip-jar" },
      { label: "About us", link: "/about-us" },
      { label: "Glossary", link: "/glossary" },
      { label: "Faq", link: "/faq" },
      { label: "Atlas", link: "/atlas" },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Brigid", link: "https://www.brigid.blue" },
      { label: "a11yStart", link: "https://a11ystart.blue" },
      { label: "a11yPage", link: "https://www.a11ypage.blue" },
      { label: "Try this", link: "/a11ystart/try-this" },
    ],
  },
];
